import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useFind: useLearningOutcomes } = getCRUDHooks<{ id: number; title: string }>({
  entityName: 'learning-outcomes',
  getHelper: () => clientApi.getOCClient().helpers.learningContent.learningOutcomes,
});

// eslint-disable-next-line import/prefer-default-export
export { useLearningOutcomes };
